import ImgBlog1 from "../images/img-blog-1.svg";
import ImgBlog2 from "../images/img-blog-2.svg";
import ImgBlog3 from "../images/img-blog-3.svg";
import ImgBlog4 from "../images/img-blog-4.svg";
import PhotoRubyPerrin from "../images/photo-ruby-perrin.svg";
import PhotoDarrenElder from "../images/photo-darren-elder.svg";
import PhotoDeborahAngel from "../images/photo-deborah-angel.svg";
import PhotoSofiahBrient from "../images/photo-sofiah-brient.svg";

const blogs = [
    {
      image: ImgBlog1,
      photo: PhotoRubyPerrin,
      name: "Dr. Ruby Perrin",
      date: "2 Dec 2019",
      title: "Doccure – Making your clinic painless visit?",
      description:
        "Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed do eiusmod tempor.",
    },
    {
      image: ImgBlog2,
      photo: PhotoDarrenElder,
      name: "Dr. Darren Elder",
      date: "3 Dec 2019",
      title: "What are the benefits of Online Doctor Booking?",
      description:
        "Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed do eiusmod tempor.",
    },
    {
      image: ImgBlog3,
      photo: PhotoDeborahAngel,
      name: "Dr. Deborah Angel",
      date: "3 Dec 2019",
      title: "Benefits of consulting with an Online Doctor",
      description:
        "Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed do eiusmod tempor.",
    },
    {
      image: ImgBlog4,
      photo: PhotoSofiahBrient,
      name: "Dr. Sofiah Brient",
      date: "2 Dec 2019",
      title: "5 Great reasons to use an Online Doctor",
      description:
        "Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed do eiusmod tempor.",
    },
  ];

  export default blogs